<template>
  <section class="section-tours" id="section-tours">
    <div class="u-text-center u-mb-8">
      <h2 class="heading-secondary">
        Viajes disponibles
      </h2>
    </div>
    <div class="row">
      <div class="col-1-of-3">
        <!-- Tour 1 -->
        <div class="card">
          <div class="card__side card__side--front">
            <div class="card__picture card__picture--1">&nbsp;</div>
            <h4 class="card__heading">
              <span class="card__heading-span card__heading-span--1"
                >Oaxaca</span
              >
            </h4>
            <div class="card__details">
              <ul>
                <li>28 al 31 de junio</li>
                <li>Puerto escondido</li>
                <li>Mazunte</li>
                <li>Playas secretas</li>
                <li>Atardecer en punta cometa</li>
              </ul>
            </div>
          </div>
          <div class="card__side card__side--back card__side--back-1">
            <div class="card__cta">
              <div class="card__price-box">
                <p class="card__price-text">Precio</p>
                <p class="card__price-number">$3,499</p>
              </div>
              <a class="btn heading__button" href="#popup">Reservar</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1-of-3">
        <!-- Tour 2 -->
        <div class="card">
          <div class="card__side card__side--front">
            <div class="card__picture card__picture--2">&nbsp;</div>
            <h4 class="card__heading">
              <span class="card__heading-span card__heading-span--2"
                >Desiertos del norte</span
              >
            </h4>
            <div class="card__details">
              <ul>
                <li>26 al 31 de julio</li>
                <li>Dunas de bilbao</li>
                <li>Minas de mármol</li>
                <li>Río Mezquites</li>
                <li>Dunas de yeso</li>
              </ul>
            </div>
          </div>
          <div class="card__side card__side--back card__side--back-2">
            <div class="card__cta">
              <div class="card__price-box">
                <p class="card__price-text">Precio</p>
                <p class="card__price-number">$3,999</p>
              </div>
              <a class="btn heading__button" href="#popup">Reservar</a>
            </div>
          </div>
        </div>
      </div>
      <div class="col-1-of-3">
        <!-- Tour 3 -->
        <div class="card">
          <div class="card__side card__side--front">
            <div class="card__picture card__picture--3">&nbsp;</div>
            <h4 class="card__heading">
              <span class="card__heading-span card__heading-span--3"
                >Paraísos Mayas</span
              >
            </h4>
            <div class="card__details">
              <ul>
                <li>21 al 26 de julio</li>
                <li>Palenque</li>
                <li>Canal de los piratas</li>
                <li>Majahual</li>
                <li>Calakmul</li>
              </ul>
            </div>
          </div>
          <div class="card__side card__side--back card__side--back-3">
            <div class="card__cta">
              <div class="card__price-box">
                <p class="card__price-text">Precio</p>
                <p class="card__price-number">$6,499</p>
              </div>
              <a class="btn heading__button" href="#popup">Reservar</a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="u-text-center">
      <a class="btn btn-red" href="#">Ver más tours</a>
    </div>
  </section>
</template>

<script>
export default {
  name: "sectionTours",
};
</script>

<style></style>
